(function () {
  var storageKey = 'petlux-color-mode';

  function currentMode() {
    return document.documentElement.getAttribute('data-petlux-theme') === 'dark' ? 'dark' : 'light';
  }

  function syncThemeControls() {
    var isDark = currentMode() === 'dark';
    document.querySelectorAll('[data-petlux-theme-toggle]').forEach(function (button) {
      var label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', label);
      var hiddenLabel = button.querySelector('[data-petlux-theme-label]');
      if (hiddenLabel) hiddenLabel.textContent = label;
    });
  }

  function setTheme(mode, persist) {
    var safeMode = mode === 'dark' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-petlux-theme', safeMode);
    if (persist) {
      try { window.localStorage.setItem(storageKey, safeMode); } catch (error) {}
    }
    syncThemeControls();
  }

  document.addEventListener('click', function (event) {
    var themeButton = event.target.closest('[data-petlux-theme-toggle]');
    if (themeButton) {
      setTheme(currentMode() === 'dark' ? 'light' : 'dark', true);
      return;
    }

    var socialTrigger = event.target.closest('.petlux-social-contact__trigger');
    if (socialTrigger) {
      var contact = socialTrigger.closest('[data-petlux-social-contact]');
      var panel = contact && contact.querySelector('.petlux-social-contact__panel');
      if (!panel) return;
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      socialTrigger.setAttribute('aria-expanded', String(willOpen));
      return;
    }

    document.querySelectorAll('[data-petlux-social-contact]').forEach(function (contact) {
      if (contact.contains(event.target)) return;
      var panel = contact.querySelector('.petlux-social-contact__panel');
      var trigger = contact.querySelector('.petlux-social-contact__trigger');
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-petlux-social-contact]').forEach(function (contact) {
      var panel = contact.querySelector('.petlux-social-contact__panel');
      var trigger = contact.querySelector('.petlux-social-contact__trigger');
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('shopify:section:load', syncThemeControls);
  syncThemeControls();
})();
